import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getToastStatus } from './toastHelper';
import Logger, { LOG_LEVELS } from '../../utils/logger';

const log = new Logger('APPLICATION_TOAST', LOG_LEVELS.DEBUG);

class ApplicationToast extends Component {
  constructor(props) {
    super(props);
    this.toastRef = null;
    this.setToastRef = this.setToastRef.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  setToastRef(element) {
    this.toastRef = element;
  }

  componentDidMount() {
    // Register dismiss event listener
    if (typeof window !== 'undefined') {
      window.addEventListener('s-dismiss', this.handleDismiss);
    }
    // Show + consume any toast queued before this renderer mounted (e.g. dispatched on the
    // previous route. Opt-in per scope.
    if (this.props.showOnMount) {
      this.showPendingToasts();
    }
  }

  componentWillUnmount() {
    // Remove event listener
    if (typeof window !== 'undefined') {
      window.removeEventListener('s-dismiss', this.handleDismiss);
    }
    // Dismiss all toasts on unmount as per Skylab SDK guidelines
    if (this.toastRef) {
      this.toastRef.dismissAllToasts();
    }
  }

  componentDidUpdate(prevProps) {
    // Check if new toasts need to be displayed
    if (this.props.toasts.length > prevProps.toasts.length) {
      this.showToasts();
    }
  }

  createToastFor(toast) {
    if (!toast || !this.toastRef || typeof this.toastRef.createToast !== 'function') {
      return false;
    }
    this.toastRef.createToast({
      text: toast.title,
      details: toast.message,
      id: toast.id || `toast-${Date.now()}`,
      status: getToastStatus(toast.type)
    });
    return true;
  }

  showToasts() {
    this.createToastFor(this.props.toasts[this.props.toasts.length - 1]);
  }

  // Render every already-queued toast for this scope and consume it, so a toast dispatched
  // before this renderer mounted still surfaces (and never re-shows on a later mount).
  showPendingToasts() {
    this.props.toasts.forEach((toast) => {
      if (this.createToastFor(toast) && this.props.onDismiss) {
        this.props.onDismiss(toast.id);
      }
    });
  }

  handleDismiss(event) {
    log.debug('handleDismiss(): event: ', event);
    const toastId = event.detail && event.detail.id;
    if (toastId && this.props.onDismiss) {
      this.props.onDismiss(toastId);
    }
  }

  render() {
    log.debug('render(): ', this.props);
    
    return (
      <s-toasts 
        ref={this.setToastRef} 
        data-testid={this.props.testId || "application-toast"}
      />
    );
  }
}


ApplicationToast.defaultProps = {
  testId: 'application-toast',
  showOnMount: false
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);
  const inAppToasts = (state.logger && state.logger.inAppToasts) || [];
  const scope = props.scope;
  const toastIds = props.toastIds;

  const toasts = inAppToasts.filter((entry) => {
    return entry && 
      (!scope || entry.scope === scope) && 
      (!toastIds || toastIds.indexOf(entry.id) >= 0);
  });

  return {
    toasts
  };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(ApplicationToast);

